import React from 'react';
import { usePageMetadata } from '../hooks/usePageMetadata';
import { ParticlesBackground } from '../components/effects/ParticlesBackground';
import { AnimatedBlob } from '../components/effects/AnimatedBlob';
import { RevealOnScroll } from '../components/effects/RevealOnScroll';
import { GlassCard } from '../components/ui/GlassCard';
import { LeadForm } from '../components/LeadForm';

export const ContactPage: React.FC = () => {
    usePageMetadata({
        title: "Kontakt | Automatyzacja AI | BiznesBezKlikania.pl",
        description: "Skontaktuj się, aby omówić, jak AI może zrewolucjonizować Twój biznes. Zostaw kontakt — odpiszemy w kilka godzin.",
        schema: {
            "@context": "https://schema.org",
            "@type": "ContactPage",
            "name": "Kontakt – Automatyzacja Biznesu z AI",
            "description": "Formularz kontaktowy – zostaw zgłoszenie i porozmawiajmy o wdrożeniu AI w Twojej firmie.",
            "url": "https://biznesbezklikania.pl/kontakt"
        },
        ogData: { type: 'website' }
    });

    return (
        <div className="relative min-h-[calc(100vh-192px)] flex items-center justify-center overflow-hidden py-16">
            <ParticlesBackground variant="minimal" />
            <AnimatedBlob variant="mixed" />
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-bkg-light/50 to-bkg-light dark:via-bkg-dark/50 dark:to-bkg-dark pointer-events-none" />

            <div className="relative z-10 px-4 py-8 w-full max-w-xl">
                <RevealOnScroll>
                    <GlassCard variant="strong" className="text-center">
                        <h1 className="text-3xl md:text-4xl font-bold text-text-primary-light dark:text-text-primary-dark mb-3">
                            Kontakt
                        </h1>
                        <p className="text-text-secondary-light dark:text-text-secondary-dark mb-6">
                            Zostaw maila — odpisujemy w ciągu kilku godzin (pn-pt). Możesz też napisać od razu na WhatsApp po wysłaniu formularza.
                        </p>
                        <LeadForm productSlug="general" />
                    </GlassCard>
                </RevealOnScroll>
            </div>
        </div>
    );
};
